import { MouseEventHandler, useContext, useEffect, useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'
import { NextRouter, useRouter } from 'next/router'
import classNames from 'classnames'
import useWalletTokens from 'web/hooks/useWalletTokens'

type NextGawdButtonProps = {
  previous?: boolean,
  next?: boolean,
  curGawd: any,
  onClick?: Function
}

const NextGawdButton = ({ previous, next, curGawd, onClick }:NextGawdButtonProps) => {
  const router: NextRouter = useRouter()

  const ownedTokens = useWalletTokens()
  let myGawds = ownedTokens.slice() // use copy so it makes a copy of the array

  // Sort them just in case they are in the wrong order
  const index = myGawds.findIndex(g => g.id == curGawd.id())

  let selectedGawd = null
  if (next === true) {
    selectedGawd = index + 1 < myGawds.length ? myGawds[index + 1] : null
  }
  else {
    selectedGawd = index - 1 >= 0 ? myGawds[index - 1] : null
  }

  // Keyboard left/right events
  const onKeyDown = (e: KeyboardEvent) => {
    if ((e.key == "ArrowLeft" || e.key == "j" || e.key == "a") && previous) {
      goToGawd()
    }
    else if ((e.key == "ArrowRight" || e.key == "k" || e.key == "d") && next) {
      goToGawd()
    }
  }
  useEffect(() => {
    document.addEventListener("keydown", onKeyDown, false);

    return () => {
      document.removeEventListener("keydown", onKeyDown, false);
    }
  }, [previous, next, curGawd.id()])

  const goToGawd = () => {
    if (selectedGawd) {
      if (onClick) {
        onClick()
      }

      router.push(`/gallery/${selectedGawd?.id}`)
    }
  }

  return (
    <div className="table h-full w-full">
      {selectedGawd &&
        <a href={`#/gallery/${selectedGawd?.id}`}
          onClick={(e) => {
            e.stopPropagation()
            goToGawd()
          }}
          className={classNames(
            'table-cell align-middle h-full transition-all ease-out duration-300',
            next ?
              'text-left  md:pl-10 md:hover:pl-11' :
              'text-right md:pr-10 md:hover:pr-11'
          )}>
          {/* className={next ? styles.nextGawdBtn : styles.prevGawdBtn}> */}
          {previous ?
            <ChevronLeftIcon className="w-6 md:w-10 inline" />
            :
            <ChevronRightIcon className="w-6 md:w-10 inline" />
          }
        </a>
      }
    </div>
  )
}
export default NextGawdButton